import { c as _c } from "react/compiler-runtime";
import { Typography } from "@/shared/ui/atoms";
interface ReviewRowProps {
  label: string;
  description: string;
  percent: string;
  stacked?: boolean;
}
const ReviewRow = t0 => {
  const $ = _c(26);
  const {
    label,
    description,
    percent,
    stacked: t1
  } = t0;
  const stacked = t1 === undefined ? false : t1;
  if (stacked) {
    let t2;
    if ($[0] !== label) {
      t2 = <Typography size={13} lineHeight={18} className="inline-flex min-h-[24px] max-w-full items-center rounded bg-primary-50 px-2 py-1 text-left font-medium text-gray-800 break-words [overflow-wrap:anywhere]">{label}</Typography>;
      $[0] = label;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== description) {
      t3 = <Typography size={14} lineHeight={18} className="mt-1 min-w-0 font-semibold text-[#46474C] break-words [overflow-wrap:anywhere]">{description}</Typography>;
      $[2] = description;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
      t4 = <div className="min-w-0 flex-1">{t2}{t3}</div>;
      $[4] = t2;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="h-px w-4 shrink-0 bg-[repeating-linear-gradient(to_right,#d1d5db_0_2px,transparent_2px_4px)]" />;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <span className="text-[14px] font-semibold">%</span>;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== percent) {
      t7 = <Typography size={16} className="shrink-0 text-gray-400">{percent}{t6}</Typography>;
      $[9] = percent;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== t4 || $[12] !== t7) {
      t8 = <div className="flex min-w-0 items-center gap-2">{t4}{t5}{t7}</div>;
      $[11] = t4;
      $[12] = t7;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    return t8;
  }
  let t2;
  if ($[14] !== label) {
    t2 = <Typography size={13} lineHeight={18} className="flex items-center justify-center px-1 min-w-[60px] h-[24px] bg-primary-50 rounded text-center text-gray-800 font-medium tracking-[-0.26px]">{label}</Typography>;
    $[14] = label;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== description) {
    t3 = <Typography size={14} lineHeight={18} className="text-[#46474C] font-semibold tracking-[-0.28px]">{description}</Typography>;
    $[16] = description;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="h-px min-w-[8px] flex-1 bg-[repeating-linear-gradient(to_right,#d1d5db_0_2px,transparent_2px_4px)]" />;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-[14px] font-semibold">%</span>;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== percent) {
    t6 = <Typography size={16} className="text-gray-400">{percent}{t5}</Typography>;
    $[20] = percent;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t2 || $[23] !== t3 || $[24] !== t6) {
    t7 = <div className="flex items-center justify-start gap-2">{t2}{t3}{t4}{t6}</div>;
    $[22] = t2;
    $[23] = t3;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};
export default ReviewRow;